import { render, staticRenderFns } from "./RegionSelectButton.vue?vue&type=template&id=1ca05de3"
import script from "./RegionSelectButton.vue?vue&type=script&lang=js"
export * from "./RegionSelectButton.vue?vue&type=script&lang=js"
import style0 from "./RegionSelectButton.vue?vue&type=style&index=0&id=1ca05de3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports